define('util/composer/editorStateUtil',[

], function() {
    "use strict";

    var utils = {};

    /*
        Creates a function that wraps an observable/computed property to update another observable when the wrapped property is changed

        Usage:
            //In the editor state
            editorState.isModified = ko.observable();
            editorState.trackModified = editorStateUtil.generateTrackModified(editorState.isModified);

            //In the view model
            viewModel.property = editorState.trackModified(viewModel, model.property);
    */
    utils.generateTrackModified = function(modifiedStateObservable) {
        return function (viewModel, observable) {
            return viewModel.computed({
                read: function formEditorState_trackModifiedRead() {
                    return observable();
                },
                write: function formEditorState_trackModifiedWrite(newVal) {
                    var oldVal = observable();
                    if(oldVal !== newVal) {
                        modifiedStateObservable(true);
                    }
                    return observable(newVal);
                },
                deferEvaluation: true
            });
        };
    };

    return utils;

});
